import { OrderingOperations } from 'polygon-ordering';
import { RedcatApiHandler } from 'polygon-utils';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../app/hooks';
import StandardButton from '../components/StandardButton';
import Text from '../components/Text';
import { enqueueErrorSnackbar, enqueueWarningSnackbar } from '../utils/snackbar';

const { removeMember } = OrderingOperations;

export const DELETE_ACCOUNT_ROUTE = '/delete-account';

const DeleteAccountScreen = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [isSubmitting, setSubmitting] = useState(false);

  // should be the same endpoint to update the password
  const handleSubmit = () => {
    setSubmitting(true);
    const path = '/api/v1/profile/remove';
    RedcatApiHandler.authorisedFetch({
      path,
      method: 'POST',
      body: {},
    })
      .then((response: { success: any }) => {
        //@ts-ignore
        // if (response.token) {
        //   dispatch(syncMember());
        // }

        if (response.success) {
          dispatch(removeMember());
          enqueueWarningSnackbar(t('snackbarMessages.accountDeleted'));

          //   setSubmitting(false);
          //   resetForm({ values });
        }
      })
      .catch((err: string | Error) => {
        enqueueErrorSnackbar(err);
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <div className="position-relative" style={{ marginTop: 20 }}>
      <Text value={t('deleteAccountDetails')} style={{ textAlign: 'left', fontSize: 16 }} />
      <div style={{ paddingTop: 50, margin: '0 50px' }}>
        <StandardButton
          containerStyle={styles.button}
          themeKey="loyaltyButton"
          label={t('button.deleteAccount')}
          onClick={handleSubmit}
          disabled={false}
          showSpinner={isSubmitting}
        />
      </div>
    </div>
  );
};

const styles: Styles = {
  button: {
    borderRadius: 5,
    height: 40,
  },
};

export default DeleteAccountScreen;
